import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import Restaurant from '../../../app/data/models/restaurant';

export interface RestaurantsCacheState {
  restaurants: { [id: string]: Restaurant };
  status: string;
}

const initialState: RestaurantsCacheState = {
  restaurants: {},
  status: 'idle',
};

export const fetchCachedRestaurantAsync = createAsyncThunk<Restaurant, string>(
  'customer/restaurantsCache/details',
  async (restaurantId, thunkApi) => {
    try {
      return await api.CustomerRestaurant.details(restaurantId);
    } catch (error: any) {
      return thunkApi.rejectWithValue({ error: error.data });
    }
  }
);

export const restaurantsCacheSlice = createSlice({
  name: 'customerRestaurants',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCachedRestaurantAsync.pending, (state) => {
      state.status = 'pendingFetchCachedRestaurant';
    });
    builder.addCase(fetchCachedRestaurantAsync.fulfilled, (state, action) => {
      if (action.payload) {
        state.restaurants[action.payload.id] = action.payload;
      }
      state.status = 'idle';
    });
    builder.addCase(fetchCachedRestaurantAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
